const disableReasonsModel = vm => ({
  title: vm.$gettext('Disable User Reasons'),
  endpoint: 'disable-reasons',
  allowNew: true,
  fields: [
    {
      key: 'id',
      sortable: true
    },
    {
      key: 'name',
      label: vm.$gettext('Name'),
      sortable: true,
      editable: true,
      description: vm.$gettext('Name for the reason'),
      required: true
    },
    {
      key: 'description',
      label: vm.$gettext('Description'),
      editable: true,
      description: vm.$gettext('Description for the reason'),
      required: true
    },
    {
      key: 'reversible',
      label: vm.$gettext('Reversible'),
      editable: true,
      type: Boolean,
      description: vm.$gettext('Whether a model disabled with this reason can be reenabled or not'),
      required: true
    },
    {
      key: 'model_type',
      label: vm.$gettext('Entity'),
      editable: true,
      description: vm.$gettext('Indicates to which kind of entity this reason applies'),
      type: 'select',
      options: [{ text: vm.$gettext('User'), value: 'Api\\Users\\Models\\User' }],
      required: true
    }
  ],
  filters: ['id', 'name', 'model_type']
})

export default disableReasonsModel
